export const SIDEBAR_MIN_WIDTH = 84
export const SIDEBAR_MAX_WIDTH = 288
